export default {
  registerCode: (state) => {
    return state.registerCode;
  },

  token: (state) => {
    return state.token;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },

  checkNewRegister: (state) => {
    return state.checkNewRegister;
  },

  forgotCode: (state) => {
    return state.forgotCode;
  },

  profile: (state) => {
    return state.profile;
  },

  companies: (state) => {
    return state.companies;
  },

  company: (state) => {
    return state.company;
  },

  printCompany: (state) => {
    return state.printCompany;
  },

  transactions: (state) => {
    return state.transactions;
  },

  wallet: (state) => {
    return state.wallet;
  },

  paymentGateway: (state) => {
    return state.paymentGateway;
  },

  paymentResult: (state) => {
    return state.paymentResult;
  },

  invoices: (state) => {
    return state.invoices;
  },
  invoiceById: (state) => {
    return state.invoiceById;
  },

  billSubjects: (state) => {
    return state.billSubjects;
  },
  billSubjectOptions: (state) => {
    const list = [];
    state.billSubjects.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  billTypes: (state) => {
    return state.billTypes;
  },
  billTypeOptions: (state) => {
    const list = [];
    state.billTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  billPatterns: (state) => {
    return state.billPatterns;
  },
  billPatternOptions: (state) => {
    const list = [];
    state.billPatterns.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  buyerTypeOptions: (state) => {
    const list = [];
    state.buyerTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  flightTypeOptions: (state) => {
    const list = [];
    state.flightTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  clearingMethodOptions: (state) => {
    const list = [];
    state.clearingMethods.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  paymentTypeOptions: (state) => {
    const list = [];
    state.paymentTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  unitMeasurementOptions: (state) => {
    const list = [];
    state.unitMeasurements.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      list.push(pushItem);
    }
    return list;
  },

  currencyTypeOptions: (state) => {
    const list = [];
    state.currencyTypes.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        iso: item.iso,
        label: item.title + " " + item.description + " (" + item.iso + ")",
      };
      list.push(pushItem);
    }
    return list;
  },

  inquiryInvoiceLogs: (state) => {
    return state.inquiryInvoiceLogs;
  },

  inquiryCheck: (state) => {
    return state.inquiryCheck;
  },

  invoiceFileLink: (state) => {
    return state.invoiceFileLink;
  },

  printAddress: (state) => {
    return state.printAddress;
  },

  taxKeys: (state) => {
    return state.taxKeys;
  },

  taxKeyByNational: (state) => {
    return state.taxKeyByNational;
  },

  publicKeyLink: (state) => {
    return state.publicKeyLink;
  },

  pfxResult: (state) => {
    return state.pfxResult;
  },

  companyFinalPrice: (state) => {
    return state.companyFinalPrice;
  },
  militaryService: (state) => {
    return state.militaryService;
  },
  militaryServiceOptions: (state) => {
    const militaryServiceOptions = [];
    state.militaryService.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      militaryServiceOptions.push(pushItem);
    }
    return militaryServiceOptions;
  },
  jobAdvertisement: (state) => {
    return state.jobAdvertisement;
  },
  jobAdvertisementById: (state) => {
    return state.jobAdvertisementById;
  },
  jobRequest: (state) => {
    return state.jobRequest;
  },
  jobRequestById: (state) => {
    return state.jobRequestById;
  },
  
  news: (state) => {
    return state.news;
  },
  newsDetail: (state) => {
    return state.newsDetail;
  },
  // static getter --------------------------------------------------------
  MaritalOptions() {
    return [
      { id: 1, label: "مجرد" },
      { id: 2, label: "متاهل" },
    ];
  },
  workExperienceOptions() {
    return [
      { id: 1, label: "کمتر از سه سال" },
      { id: 2, label: "سه تا شش سال" },
      { id: 3, label: "بیش از شش سال" },
      { id: 4, label: "مهم نیست" },
    ];
  },
  employeesCountOptions() {
    return [
      { id: "1", label: "کمتر از 10 نفر" },
      { id: "2", label: "10 - 50 نفر" },
      { id: "3", label: "50 - 100 نفر" },
      { id: "4", label: "100 - 200 نفر" },
      { id: "5", label: "200 - 300 نفر" },
      { id: "6", label: "300 - 400 نفر" },
      { id: "7", label: "400 - 500 نفر" },
      { id: "8", label: "بیش از 500 نفر" },
    ];
  },
};
